{
  "bankAccounts": {
    "title": "Cuentas Bancarias",
    "connectTitle": "Conectar Cuenta Bancaria",
    "emptyState": {
      "title": "Ninguna Cuenta Bancaria Conectada",
      "description": "Conecta tu cuenta bancaria para habilitar depósitos y retiros de tu pool de inversión.",
      "connectButton": "Conectar Cuenta Bancaria"
    },
    "connected": {
      "title": "Cuenta Bancaria Conectada",
      "description": "Tu cuenta bancaria está vinculada y lista para transacciones",
      "comingSoon": "Los detalles de la cuenta y las opciones de administración estarán disponibles pronto"
    },
    "connect": {
      "title": "Conecta Tu Cuenta Bancaria",
      "description": "Vincula de forma segura tu cuenta bancaria para habilitar depósitos y retiros. Tus credenciales nunca se almacenan en nuestros servidores.",
      "button": "Conectar Cuenta Bancaria",
      "initializing": "Inicializando...",
      "connecting": "Conectando tu cuenta bancaria...",
      "success": "¡Cuenta bancaria conectada exitosamente!",
      "error": {
        "title": "Error de Conexión",
        "retry": "Intentar de Nuevo",
        "initFailed": "No se pudo inicializar la conexión bancaria",
        "connectFailed": "No se pudo conectar la cuenta bancaria"
      }
    },
    "list": {
      "addAccountButton": "Agregar Cuenta",
      "syncButton": "Actualizar Cuentas",
      "noAccounts": "No se encontraron cuentas. Haz clic en actualizar para sincronizar desde tu banco.",
      "fetchError": "Error al cargar cuentas bancarias",
      "syncSuccess": "Cuentas bancarias sincronizadas exitosamente",
      "syncError": "Error al sincronizar cuentas bancarias"
    },
    "status": {
      "active": "Activa",
      "disconnected": "Desconectada",
      "disabled": "Deshabilitada"
    },
    "reconnect": {
      "badge": "Desconectada",
      "button": "Reconectar",
      "modal": {
        "title": "Reconectar Cuenta Bancaria",
        "description": "Su conexión bancaria se ha desconectado. Deberá iniciar sesión nuevamente para restaurar el acceso a sus cuentas bancarias.",
        "confirm": "Reconectar Ahora",
        "cancel": "Cancelar"
      },
      "success": "Cuenta bancaria reconectada exitosamente",
      "error": "Error al reconectar cuenta bancaria"
    },
    "default": {
      "badge": "Predeterminada",
      "setButton": "Establecer como Predeterminada",
      "setSuccess": "Cuenta bancaria predeterminada actualizada exitosamente",
      "setError": "Error al establecer cuenta bancaria predeterminada"
    },
    "disable": {
      "button": "Deshabilitar",
      "modal": {
        "title": "Deshabilitar Cuenta Bancaria",
        "description": "¿Está seguro de que desea deshabilitar esta cuenta bancaria? Ya no estará disponible para transacciones.",
        "reasonLabel": "Razón",
        "reasonPlaceholder": "Seleccione una razón",
        "reasonTextLabel": "Detalles adicionales (opcional)",
        "reasonTextPlaceholder": "Proporcione más información...",
        "replacementLabel": "Establecer nueva cuenta predeterminada",
        "replacementPlaceholder": "Seleccione un reemplazo",
        "replacementNote": "Esta cuenta es actualmente su predeterminada. Seleccione una nueva predeterminada o se borrará la predeterminada.",
        "confirm": "Deshabilitar Cuenta",
        "cancel": "Cancelar"
      },
      "reasons": {
        "no_longer_used": "Ya no se usa",
        "wrong_account": "Cuenta incorrecta vinculada",
        "security_concern": "Preocupación de seguridad",
        "duplicate": "Cuenta duplicada",
        "other": "Otro"
      },
      "success": "Cuenta bancaria deshabilitada exitosamente",
      "error": "Error al deshabilitar cuenta bancaria",
      "errorActiveTransfers": "No se puede deshabilitar cuenta con transferencias activas o pendientes"
    }
  },
  "accountTypes": {
    "checking": "Corriente",
    "savings": "Ahorros",
    "depository": "Depósito"
  },
  "companyBankAccounts": {
    "title": "Cuenta Bancaria de la Empresa",
    "connectTitle": "Conectar Cuenta Bancaria de la Empresa",
    "warning": {
      "title": "Cuenta Bancaria de la Empresa",
      "description": "Esto conectará la cuenta bancaria de la empresa para depósitos y pagos. Solo los administradores autorizados deben realizar esta acción."
    },
    "emptyState": {
      "title": "Ninguna Cuenta Bancaria de la Empresa Conectada",
      "description": "Conecta la cuenta bancaria de la empresa para habilitar depósitos de fondos y procesar retiros.",
      "connectButton": "Conectar Cuenta Bancaria de la Empresa"
    },
    "connected": {
      "title": "Cuenta Bancaria de la Empresa Conectada",
      "description": "La cuenta bancaria de la empresa está vinculada y lista para transacciones",
      "comingSoon": "Los detalles de la cuenta y las opciones de administración estarán disponibles pronto"
    },
    "connect": {
      "title": "Conectar Cuenta Bancaria de la Empresa",
      "description": "Vincula de forma segura la cuenta bancaria de la empresa. Esto se utilizará como fuente para depósitos y destino para retiros.",
      "button": "Conectar Cuenta Bancaria de la Empresa",
      "initializing": "Inicializando conexión bancaria de la empresa...",
      "connecting": "Conectando cuenta bancaria de la empresa...",
      "success": "¡Cuenta bancaria de la empresa conectada exitosamente!",
      "error": {
        "title": "Error de Conexión",
        "retry": "Intentar de Nuevo",
        "initFailed": "No se pudo inicializar la conexión bancaria de la empresa",
        "connectFailed": "No se pudo conectar la cuenta bancaria de la empresa"
      }
    },
    "list": {
      "addAccountButton": "Agregar Cuenta",
      "syncButton": "Actualizar Cuentas",
      "noAccounts": "No se encontraron cuentas. Haga clic en actualizar para sincronizar desde el banco.",
      "fetchError": "Error al cargar las cuentas bancarias de la compañía",
      "syncSuccess": "Cuentas bancarias de la compañía sincronizadas exitosamente",
      "syncError": "Error al sincronizar las cuentas bancarias de la compañía"
    },
    "reconnect": {
      "badge": "Desconectada",
      "button": "Reconectar",
      "modal": {
        "title": "Reconectar Cuenta Bancaria de la Compañía",
        "description": "La conexión bancaria de la compañía se ha desconectado. Deberá iniciar sesión nuevamente para restaurar el acceso a las cuentas bancarias de la compañía.",
        "confirm": "Reconectar Ahora",
        "cancel": "Cancelar"
      },
      "success": "Cuenta bancaria de la compañía reconectada exitosamente",
      "error": "Error al reconectar cuenta bancaria de la compañía"
    },
    "default": {
      "badge": "Predeterminada",
      "setButton": "Establecer como Predeterminada",
      "setSuccess": "Cuenta bancaria predeterminada de la empresa actualizada exitosamente",
      "setError": "Error al establecer la cuenta bancaria predeterminada de la empresa",
      "missing": {
        "title": "No Hay Cuenta de Origen Predeterminada Configurada",
        "description": "Por favor, establezca una cuenta bancaria predeterminada de la empresa para habilitar depósitos y pagos. Haga clic en 'Establecer como Predeterminada' en cualquier cuenta activa."
      }
    },
    "disable": {
      "button": "Deshabilitar",
      "modal": {
        "title": "Deshabilitar Cuenta Bancaria de la Compañía",
        "description": "¿Está seguro de que desea deshabilitar esta cuenta bancaria de la compañía? Ya no estará disponible para transacciones.",
        "reasonLabel": "Razón",
        "reasonPlaceholder": "Seleccione una razón",
        "reasonTextLabel": "Detalles adicionales (opcional)",
        "reasonTextPlaceholder": "Proporcione más información...",
        "replacementLabel": "Establecer nueva cuenta predeterminada",
        "replacementPlaceholder": "Seleccione un reemplazo",
        "replacementNote": "Esta cuenta es actualmente la predeterminada. Seleccione una nueva predeterminada o se borrará la predeterminada.",
        "confirm": "Deshabilitar Cuenta",
        "cancel": "Cancelar"
      },
      "reasons": {
        "no_longer_used": "Ya no se usa",
        "wrong_account": "Cuenta incorrecta vinculada",
        "security_concern": "Preocupación de seguridad",
        "duplicate": "Cuenta duplicada",
        "other": "Otro"
      },
      "success": "Cuenta bancaria de la compañía deshabilitada exitosamente",
      "error": "Error al deshabilitar cuenta bancaria de la compañía",
      "errorActiveTransfers": "No se puede deshabilitar cuenta con transferencias activas o pendientes"
    }
  }
}
